<div class="add-product-page">
  <div class="backButton" (click)="builderService.navigateBack()">
    <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
  </div>
  <app-stepper step="5" *ngIf="builderService.getTour()"></app-stepper>

  <!-- Product Format Selection -->
  <div class="format-selection" *ngIf="!productIdFromRoute && !productForm.value?.productFormat && !builderService.isStockManager">
    <h1 class="format-title">{{ 'Add New Product' | translate }}</h1>
    <div class="format-options">
      <div class="format-card" (click)="selectProductFormat('physical')">
        <img src="assets/images/products/physical_product.png" [alt]="'physical Product' | translate" />
        <h3>{{ 'Physical Product' | translate }}</h3>
      </div>
      <div class="format-card" (click)="selectProductFormat('digital')">
        <img src="assets/images/products/digital_product.png" [alt]="'Digital Product' | translate" />
        <h3>{{ 'Digital Product' | translate }}</h3>
      </div>
    </div>
  </div>

  <!-- Main Product Form -->
  <div class="product-form-container" *ngIf="productIdFromRoute || productForm.get('productFormat')?.value">
    <mat-progress-bar class="genie-progress-bar" mode="indeterminate" *ngIf="productProgress"></mat-progress-bar>
    <form [formGroup]="productForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
      <!-- Page Header -->
      <div class="page-header">
        <div class="header-left">
          <h1 class="page-title">{{ 'Add Product' | translate }}</h1>
          <p class="page-subtitle">{{ 'Products are shared across all channels you activated (Website, POS, Mobile App).' | translate }}</p>
        </div>
        <div class="header-right">
          <button type="button" class="cancel-btn" *ngIf="!builderService.getTour()" [routerLink]="['/products']">
            <span>{{ 'Cancel' | translate }}</span>
          </button>
          <button type="submit" class="submit-btn">
            <mat-icon>add</mat-icon>
            <span>{{ productIdFromRoute ? ('Update Product' | translate) : ('Add Product' | translate) }}</span>
          </button>
        </div>
      </div>

      <!-- Product Type Tabs -->
      <div class="product-type-tabs">
        <button type="button" class="type-tab" [class.active]="productForm.get('productType')?.value === 'simple'" (click)="productForm.get('productType')?.setValue('simple')">
          {{ 'Simple Product' | translate }}
        </button>
        <button type="button" class="type-tab" [class.active]="productForm.get('productType')?.value === 'variable'" (click)="productForm.get('productType')?.setValue('variable')">
          {{ 'Variable Product' | translate }}
        </button>
      </div>

      <!-- Main Content -->
      <div class="content-wrapper">
        <!-- Left Column -->
        <div class="left-column">
          <!-- Product Details Card -->
          <div class="form-card">
            <div class="card-header">
              <h3>{{ 'Product Details' | translate }}</h3>
            </div>
            <div class="card-content">
              <div class="form-field">
                <label class="field-label">{{ 'Product Name' | translate }}</label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="productName" placeholder="{{ 'Leather Jacket' | translate }}" />
                  <mat-error *ngIf="productForm.get('productName')?.hasError('required')">{{ 'Product Name is required' | translate }}</mat-error>
                </mat-form-field>
              </div>

              <!-- Simple Product Fields (Stock, SKU, Price) -->
                <ng-container *ngIf="productForm.get('productType')?.value === 'simple'">
                <div class="form-row">
                  <div class="form-field">
                    <label class="field-label">{{ 'Stock Quantity' | translate }}</label>
                    <mat-form-field appearance="outline">
                      <input type="number" matInput formControlName="productStock" placeholder="0" />
                      <mat-error *ngIf="productForm.get('productStock')?.hasError('required')">{{ 'Product Stock is required' | translate }}</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <label class="field-label">
                      {{ 'Sku' | translate }}
                      <mat-icon class="info-icon" matTooltip="{{ 'Stock Keeping Unit - unique identifier for this product' | translate }}">info_outline</mat-icon>
                    </label>
                    <mat-form-field appearance="outline">
                      <input matInput formControlName="productSKU" [placeholder]="'PNT-4225-776-3234' | translate" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-field">
                    <label class="field-label">{{ 'Regular Price' | translate }}</label>
                    <div class="input-with-prefix">
                      <span class="prefix">$</span>
                      <input type="number" min="0" formControlName="regularPrice" placeholder="0" />
                    </div>
                    <mat-error *ngIf="productForm.get('regularPrice')?.hasError('required') && productForm.get('regularPrice')?.touched">{{ 'Regular Price is required' | translate }}</mat-error>
                  </div>
                  <div class="form-field">
                    <label class="field-label"
                      >{{ 'Sale Price' | translate }} <span class="optional-text">({{ 'Optional' | translate }})</span></label
                    >
                    <div class="input-with-prefix">
                      <span class="prefix">$</span>
                      <input type="number" formControlName="salePrice" placeholder="0" />
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="form-row" *ngIf="categoriesService.allCategories.length">
                <div class="form-field">
                  <label class="field-label">{{ 'Category' | translate }}</label>
                  <div class="np-custom-select" (click)="toggleCategoryDropdown($event)">
                    <span [class.select-placeholder]="!productForm.get('categoriesIds')?.value?.length" class="select-value">
                      {{ productForm.get('categoriesIds')?.value?.length ? getSelectedCategoriesLabel() : ('Select Category' | translate) }}
                    </span>
                    <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="categoryDropdownOpen" />
                  </div>
                  <div class="np-dropdown-panel" *ngIf="categoryDropdownOpen" (click)="$event.stopPropagation()">
                    <div class="np-dropdown-option" [class.selected]="isCategorySelected(toStr(category.categoryId))" *ngFor="let category of categoriesService.allCategories" (click)="toggleCategoryOption(toStr(category.categoryId), $event)">
                      <div class="category-option">
                        <img [src]="category.categoryImage" />
                        <span>{{ category.categoryName }}</span>
                      </div>
                      <svg *ngIf="isCategorySelected(toStr(category.categoryId))" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 6L5 9L10 3" stroke="#3A95B9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'Subcategory' | translate }}</label>
                  <div class="np-custom-select" (click)="toggleSubCategoryDropdown($event)">
                    <span [class.select-placeholder]="!productForm.get('subCategoriesIds')?.value?.length" class="select-value">
                      {{ productForm.get('subCategoriesIds')?.value?.length ? getSelectedSubCategoriesLabel() : ('Select Subcategory' | translate) }}
                    </span>
                    <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="subCategoryDropdownOpen" />
                  </div>
                  <div class="np-dropdown-panel" *ngIf="subCategoryDropdownOpen" (click)="$event.stopPropagation()">
                    <div class="np-dropdown-option" [class.selected]="isSubCategorySelected(toStr(subCategory.subCategoryId))" *ngFor="let subCategory of allowedSubcategories" (click)="toggleSubCategoryOption(toStr(subCategory.subCategoryId), $event)">
                      <span>{{ subCategory.subcategory }}</span>
                      <svg *ngIf="isSubCategorySelected(toStr(subCategory.subCategoryId))" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 6L5 9L10 3" stroke="#3A95B9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-field">
                  <label class="field-label"
                    >{{ 'Product location' | translate }} <span class="optional-text">({{ 'Optional' | translate }})</span></label
                  >
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="location" placeholder="{{ 'Alexandria' | translate }}" />
                  </mat-form-field>
                </div>
                <div class="form-field" *ngIf="productForm?.value?.productFormat === 'physical'">
                  <label class="field-label"
                    >{{ 'Estimated Delivery' | translate }} <span class="optional-text">({{ 'Optional' | translate }})</span></label
                  >
                  <div class="input-with-suffix">
                    <mat-form-field appearance="outline" class="delivery-time-input">
                      <input type="number" matInput formControlName="estimatedDeliveryTime" placeholder="2" />
                    </mat-form-field>
                    <div class="delivery-unit-select">
                      <div class="np-custom-select" (click)="toggleDropdown('estimatedDeliveryUnit', $event)">
                        <span [class.select-placeholder]="!getOptionLabel(deliveryUnitOptions, productForm.get('estimatedDeliveryUnit')?.value)" class="select-value">
                          {{ getOptionLabel(deliveryUnitOptions, productForm.get('estimatedDeliveryUnit')?.value) || ('Days' | translate) }}
                        </span>
                        <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="dropdownOpen['estimatedDeliveryUnit']" />
                      </div>
                      <div class="np-dropdown-panel" *ngIf="dropdownOpen['estimatedDeliveryUnit']" (click)="$event.stopPropagation()">
                        <div class="np-dropdown-option" *ngFor="let opt of deliveryUnitOptions" [class.selected]="productForm.get('estimatedDeliveryUnit')?.value === opt.value" (click)="selectOption('estimatedDeliveryUnit', opt.value, $event)">
                          {{ opt.label | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Description Card -->
          <div class="form-card">
            <div class="card-header">
              <h3>{{ 'Description' | translate }}</h3>
            </div>
            <div class="card-content">
              <div class="form-field full-width">
                <label class="field-label">{{ 'Product Description' | translate }}</label>
                <div class="description-editor">
                  <editor
                    [(ngModel)]="productDescription"
                    [ngModelOptions]="{ standalone: true }"
                    apiKey="dh6nv3idqamf38bn1tnknqxd0qn9vz2yli1zjpjehily2stk"
                    (onInit)="initEditor($event)"
                    [init]="{
                      base_url: '/tinymce',
                      suffix: '.min',
                      height: 200,
                      menubar: false,
                      placeholder: 'Describe your product perfectly...',
                      plugins: ['lists', 'help', 'textcolor', 'colorpicker', 'code'],
                      toolbar: 'bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | link'
                    }"
                  ></editor>
                </div>
                <p class="char-count">0 / 1000 {{ 'characters' | translate }}</p>
              </div>
            </div>
          </div>

          <!-- Attributes Card (Variable Products Only) -->
          <div class="form-card adding-card" *ngIf="productForm?.value?.productType === 'variable'">
            <div class="card-header">
              <h3>{{ 'Attributes' | translate }}</h3>
              <button type="button" class="add-attribute-btn" (click)="addAttr()" *ngIf="!builderService.isStockManager">
                <mat-icon>add</mat-icon>
                <span>{{ 'Add Attribute' | translate }}</span>
              </button>
            </div>
            <div class="card-content">
              <!-- Empty State -->
              <div class="attributes-empty" *ngIf="!productAttributes || productAttributes.length === 0">
                <p>{{ 'No attributes defined yet. Add attributes like Size or Color to create variations.' | translate }}</p>
              </div>

              <!-- Attribute Form -->
              <div class="attributes-form" *ngIf="productAttributes && productAttributes.length > 0">
                <div class="attribute-item" *ngFor="let productAttribute of productAttributes; let i = index">
                  <!-- Content container (same width items stacked) -->
                  <div class="attribute-content">
                    <!-- Attribute Name -->
                    <div class="attribute-container">
                      <div class="form-field">
                        <label class="field-label">{{ 'Name' | translate }}</label>
                        <mat-form-field appearance="outline">
                          <input matInput [(ngModel)]="productAttribute.name" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Attribute name (size, color, or material)' | translate }}" (change)="attributeChange('attrName', $event, i)" [disabled]="builderService.isStockManager"/>
                        </mat-form-field>
                      </div>

                      <!-- Attribute Values -->
                      <div class="form-field attribute-value-field">
                        <label class="field-label">{{ 'Value' | translate }}</label>
                        <mat-form-field appearance="outline" floatLabel="always">
                          <mat-chip-grid #attrChipGrid>
                            <input #attrValueInput placeholder="{{ 'Type a value and press Enter' | translate }}" [matChipInputFor]="attrChipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addAttributeValue($event, i)" (keydown.escape)="cancelAttributeValueEdit(attrValueInput)" [disabled]="builderService.isStockManager"/>
                          </mat-chip-grid>
                        </mat-form-field>
                        <mat-chip-set class="tags-row" [class.editable-chips]="!builderService.isStockManager" *ngIf="getAttributeValues(i)?.length">
                          <mat-chip *ngFor="let val of getAttributeValues(i)" [removable]="true" (removed)="removeAttributeValue(i, val)" (click)="startAttributeValueEdit(i, val, attrValueInput)" [class.editing]="isEditingAttributeValue(i, val)">
                            {{ val }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                    </div>

                    <button type="button" class="attribute-remove-btn" (click)="removeAttr(i)" aria-label="Remove attribute" *ngIf="!builderService.isStockManager">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.1924 1.70711C10.583 1.31658 10.583 0.68342 10.1924 0.29289C9.80186 -0.09763 9.16866 -0.09763 8.77816 0.29289L5.24266 3.82844L1.70711 0.29289C1.31658 -0.09763 0.68342 -0.09763 0.29289 0.29289C-0.09763 0.68342 -0.09763 1.31658 0.29289 1.70711L3.82846 5.24264L0.29289 8.77814C-0.09763 9.16874 -0.09763 9.80184 0.29289 10.1923C0.68342 10.5829 1.31658 10.5829 1.70711 10.1923L5.24266 6.65684L8.77816 10.1923C9.16866 10.5829 9.80186 10.5829 10.1924 10.1923C10.583 9.80184 10.583 9.16874 10.1924 8.77814L6.65686 5.24264L10.1924 1.70711Z"
                          fill="#ADADAD"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <div class="attributes-actions">
                  <button type="button" class="save-attributes-btn" [class.active]="hasValidAttributes()" [disabled]="!hasValidAttributes()" (click)="saveAttributes()" *ngIf="!builderService.isStockManager">
                    {{ 'Save' | translate }}
                  </button>
                </div>
              </div>

              <!-- Variations Table -->
              <div class="genie-table-wrapper variations-table-wrapper" *ngIf="productVariations && productVariations.length > 0 && !mobile">
                <table class="genie-table">
                  <thead>
                    <tr>
                      <th class="col-variation">{{ 'Variation' | translate }}</th>
                      <th class="col-center">{{ 'Stock' | translate }}</th>
                      <th class="col-center">{{ 'Price' | translate }}</th>
                      <th class="col-center">{{ 'Sale Price' | translate }}</th>
                      <th class="col-center">{{ 'Sku' | translate }}</th>
                      <th class="col-center">{{ 'Publish' | translate }}</th>
                      <th class="col-action"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let variation of productVariations; let i = index">
                      <td class="col-variation">
                        <div class="variation-info">
                          <label class="variation-image-thumb" [style.pointer-events]="builderService.isStockManager ? 'none' : 'auto'" [style.opacity]="builderService.isStockManager ? '0.6' : '1'">
                            <img *ngIf="variation.image" [src]="variation.image" [alt]="'Variation' | translate" />
                            <mat-icon *ngIf="!variation.image">image</mat-icon>
                            <input type="file" hidden (change)="onVarFileSelected($event, 'variation', i)" accept="image/*" />
                          </label>
                          <div class="variation-details">
                            <span class="variation-name">{{ getVariationName(variation) }}</span>
                            <span class="variation-attributes">{{ getVariationAttributesText(variation) }}</span>
                          </div>
                        </div>
                      </td>
                      <td class="col-center">
                        <input type="number" [(ngModel)]="variation.stock" [ngModelOptions]="{ standalone: true }" (change)="variationChange('stock', variation.stock, i, variation.values)" />
                      </td>
                      <td class="col-center">
                        <input type="number" [(ngModel)]="variation.regularPrice" [ngModelOptions]="{ standalone: true }" (change)="variationChange('regularPrice', variation.regularPrice, i, variation.values)" [disabled]="builderService.isStockManager" />
                      </td>
                      <td class="col-center">
                        <input type="number" [(ngModel)]="variation.salePrice" [ngModelOptions]="{ standalone: true }" (change)="variationChange('salePrice', variation.salePrice, i, variation.values)" [disabled]="builderService.isStockManager" />
                      </td>
                      <td class="col-center">
                        <input type="text" [(ngModel)]="variation.sku" [ngModelOptions]="{ standalone: true }" placeholder="-" (change)="variationChange('sku', variation.sku, i, variation.values)" [disabled]="builderService.isStockManager" />
                      </td>
                      <td class="col-center">
                        <label class="toggle-switch">
                          <input type="checkbox" [checked]="variation.publish" (change)="variation.publish = $any($event.target).checked; variationChange('publish', variation.publish, i, variation.values)" [disabled]="builderService.isStockManager" />
                          <span class="toggle-slider"></span>
                        </label>
                      </td>
                      <td class="col-action" *ngIf="!builderService.isStockManager">
                        <button type="button" class="delete-variation-btn" (click)="removeVar(i)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Mobile Card List for Variations -->
              <div class="variations-mobile-list" *ngIf="productVariations && productVariations.length > 0 && mobile">
                <div class="variation-mobile-card" *ngFor="let variation of productVariations; let i = index">
                  <label class="card-image" [style.pointer-events]="builderService.isStockManager ? 'none' : 'auto'" [style.opacity]="builderService.isStockManager ? '0.6' : '1'">
                    <img *ngIf="variation.image" [src]="variation.image" [alt]="'Variation' | translate" />
                    <mat-icon *ngIf="!variation.image">image</mat-icon>
                    <input type="file" hidden (change)="onVarFileSelected($event, 'variation', i)" accept="image/*" />
                  </label>
                  <div class="card-details">
                    <div class="title">{{ getVariationName(variation) }}</div>
                    <div class="subtitle">{{ getVariationAttributesText(variation) }}</div>
                    <div class="card-row">
                      <div class="field">
                        <span class="label">{{ 'Stock' | translate }}</span>
                        <input type="number" [(ngModel)]="variation.stock" [ngModelOptions]="{ standalone: true }" (change)="variationChange('stock', variation.stock, i, variation.values)" />
                      </div>
                      <div class="field">
                        <span class="label">{{ 'Price' | translate }}</span>
                        <input type="number" [(ngModel)]="variation.regularPrice" [ngModelOptions]="{ standalone: true }" (change)="variationChange('regularPrice', variation.regularPrice, i, variation.values)" [disabled]="builderService.isStockManager" />
                      </div>
                    </div>
                    <div class="card-row">
                      <div class="field">
                        <span class="label">{{ 'Sale Price' | translate }}</span>
                        <input type="number" [(ngModel)]="variation.salePrice" [ngModelOptions]="{ standalone: true }" (change)="variationChange('salePrice', variation.salePrice, i, variation.values)" [disabled]="builderService.isStockManager" />
                      </div>
                      <div class="field">
                        <span class="label">{{ 'Sku' | translate }}</span>
                        <input type="text" [(ngModel)]="variation.sku" [ngModelOptions]="{ standalone: true }" placeholder="-" (change)="variationChange('sku', variation.sku, i, variation.values)" [disabled]="builderService.isStockManager" />
                      </div>
                    </div>
                  </div>
                  <div class="card-actions">
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="variation.publish" (change)="variation.publish = $any($event.target).checked; variationChange('publish', variation.publish, i, variation.values)" [disabled]="builderService.isStockManager" />
                      <span class="toggle-slider"></span>
                    </label>
                    <button *ngIf="!builderService.isStockManager" type="button" class="delete-variation-btn" (click)="removeVar(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- QR CODE SECTION PER VARIATION (Digital Products Only) -->
              <div class="variation-codes-section" *ngIf="productForm?.value?.productFormat === 'digital' && productVariations && productVariations.length > 0">
                <div class="variation-code-item" *ngFor="let variation of productVariations; let indexOfelement = index">
                  <mat-accordion>
                    <mat-expansion-panel class="codes-panel" hideToggle>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span class="variation-code-title">{{ getVariationName(variation) }} - {{ 'Codes' | translate }}</span>
                          <span class="codes-count">({{ variation.codes?.length || 0 }} {{ 'Codes' | translate }})</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="codes-content codes-section">
                        <div class="codes-header">
                          <h4>{{ 'Enter Data for Code' | translate }}</h4>
                          <div class="codes-input-row">
                            <input type="text" class="code-input" [(ngModel)]="newCode[indexOfelement]" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Enter Code' | translate }}" />
                            <button (click)="addCode(indexOfelement)" type="button" class="btn-primary">{{ 'Add' | translate }}</button>
                          </div>
                        </div>

                        <mat-tab-group class="codes-tabs" (selectedTabChange)="filterQrCodesByTab($event.index, indexOfelement)" [selectedIndex]="selectedTabIndex[indexOfelement]">
                          <mat-tab>
                            <ng-template mat-tab-label>{{ 'All' | translate }}</ng-template>
                            <ng-template matTabContent>
                              <ng-container *ngTemplateOutlet="qrTableVar; context: { idx: indexOfelement }"></ng-container>
                            </ng-template>
                          </mat-tab>
                          <mat-tab>
                            <ng-template mat-tab-label>{{ 'Purchased' | translate }}</ng-template>
                            <ng-template matTabContent>
                              <ng-container *ngTemplateOutlet="qrTableVar; context: { idx: indexOfelement }"></ng-container>
                            </ng-template>
                          </mat-tab>
                          <mat-tab>
                            <ng-template mat-tab-label>{{ 'Valid' | translate }}</ng-template>
                            <ng-template matTabContent>
                              <ng-container *ngTemplateOutlet="qrTableVar; context: { idx: indexOfelement }"></ng-container>
                            </ng-template>
                          </mat-tab>
                        </mat-tab-group>

                        <ng-template #qrTableVar let-idx="idx">
                          <div class="codes-table-wrapper">
                            <table mat-table [dataSource]="filteredCodesVariation[indexOfelement]" class="codes-table">
                              <ng-container matColumnDef="Code">
                                <th mat-header-cell *matHeaderCellDef>{{ 'Code' | translate }}</th>
                                <td mat-cell *matCellDef="let code">{{ code.value }}</td>
                              </ng-container>

                              <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>{{ 'Type' | translate }}</th>
                                <td mat-cell *matCellDef="let code; let i = index">
                                  <div class="code-type-select-wrap">
                                    <div class="np-custom-select type-select" (click)="toggleCodeTypeDropdown(i, indexOfelement, $event)">
                                      <span class="select-value">{{ getOptionLabel(codeTypeOptions, code.codeType) }}</span>
                                      <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="codeTypeDropdownVariation[indexOfelement][i]" />
                                    </div>
                                    <div class="np-dropdown-panel" *ngIf="codeTypeDropdownVariation[indexOfelement][i]" (click)="$event.stopPropagation()">
                                      <div class="np-dropdown-option" *ngFor="let opt of codeTypeOptions" [class.selected]="code.codeType === opt.value" (click)="selectCodeTypeOption(i, indexOfelement, opt.value, $event)">
                                        {{ opt.label | translate }}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="used">
                                <th mat-header-cell *matHeaderCellDef>{{ 'Purchased' | translate }}</th>
                                <td mat-cell *matCellDef="let code; let i = index">
                                  <label class="toggle-switch">
                                    <input type="checkbox" [checked]="code.used" (change)="onToggleUsed(i, indexOfelement)" />
                                    <span class="toggle-slider"></span>
                                  </label>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef>{{ 'Action' | translate }}</th>
                                <td mat-cell *matCellDef="let code; let i = index">
                                  <button mat-icon-button type="button" class="delete-btn" (click)="removeCode(i, indexOfelement)">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </td>
                              </ng-container>

                              <tr mat-header-row *matHeaderRowDef="['Code', 'type', 'used', 'action']"></tr>
                              <tr mat-row *matRowDef="let row; columns: ['Code', 'type', 'used', 'action']"></tr>
                            </table>
                            <mat-paginator *ngIf="filteredCodesVariation[indexOfelement]" [length]="filteredCodesVariation[indexOfelement].filteredData.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                          </div>
                        </ng-template>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="right-column">
          <!-- Product Media Card -->
          <div class="form-card">
            <div class="card-header">
              <h3>{{ 'Product Media' | translate }}</h3>
            </div>
            <div class="card-content">
              <div class="media-upload-grid" (drop)="!builderService.isStockManager && onFileDrop($event)" (dragover)="!builderService.isStockManager && onDragOver($event)" (dragleave)="!builderService.isStockManager && onDragLeave($event)" [style.pointer-events]="builderService.isStockManager ? 'none' : 'auto'" [style.opacity]="builderService.isStockManager ? '0.6' : '1'">
                <!-- Main Upload Zone -->
                <label class="main-upload-zone" [class.has-image]="imageUrl && imageUrl.length > 0" [class.drag-over]="dragOver" cdkDropList #mainImageDropList="cdkDropList" [cdkDropListDisabled]="builderService.isStockManager" (cdkDropListDropped)="makeMainImage($event)">
                  <div *ngIf="!imageUrl || imageUrl.length === 0" class="upload-content">
                    <div class="upload-icon-circle">
                      <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                        <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" stroke="#F9FAFB" stroke-width="6.66667" />
                        <path
                          d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953"
                          stroke="url(#paint0_linear_3029_40085)"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <defs>
                          <linearGradient id="paint0_linear_3029_40085" x1="23.8178" y1="41.8996" x2="20.7349" y2="16.145" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#7CEEE6" />
                            <stop offset="0.495192" stop-color="#3A95B9" />
                            <stop offset="0.990385" stop-color="#004691" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <p class="upload-title">{{ 'Click to Upload Image' | translate }}</p>
                    <p class="upload-subtitle">SVG, PNG, JPG or GIF ( Max 15 mb )</p>
                  </div>
                  <div *ngIf="imageUrl && imageUrl.length > 0" class="main-image-container">
                    <img [src]="imageUrl[0]" [alt]="'Main image' | translate" />
                    <div class="image-overlay">
                      <mat-icon>edit</mat-icon>
                    </div>
                    <button type="button" class="delete-btn" (click)="removeFromImgArr(0); $event.preventDefault(); $event.stopPropagation()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                  <input type="file" hidden (change)="imageUrl && imageUrl.length > 0 ? editImg($event, 0) : onFileSelected($event)" accept="image/*" [attr.multiple]="!imageUrl || imageUrl.length === 0 ? true : null" />
                </label>

                <!-- Thumbnail Placeholders -->
                <div class="thumbnail-grid" cdkDropList [cdkDropListConnectedTo]="[mainImageDropList]" [cdkDropListDisabled]="builderService.isStockManager" (cdkDropListDropped)="reorderThumbnail($event)">
                  <!-- Uploaded thumbnails — drag to reorder, or drop on the main image to swap with it -->
                  <label *ngFor="let img of imageUrl?.slice(1, 5); let i = index" class="thumbnail-slot has-image" cdkDrag [cdkDragData]="i + 1" (cdkDragStarted)="draggingImage = true" (cdkDragEnded)="onImageDragEnded()" (click)="draggingImage && $event.preventDefault()">
                    <img [src]="img" [alt]="'Thumbnail' | translate" />
                    <div class="thumbnail-overlay">
                      <mat-icon>edit</mat-icon>
                    </div>
                    <input type="file" hidden (change)="editImg($event, i + 1)" accept="image/*" />
                    <button type="button" class="thumbnail-delete" (click)="removeFromImgArr(i + 1); $event.preventDefault(); $event.stopPropagation()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </label>

                  <!-- Empty placeholder slots -->
                  <label *ngFor="let empty of placeholderArray()" class="thumbnail-slot empty">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.83327 7.81889C5.6241 7.81889 6.26518 7.17783 6.26518 6.38699C6.26518 5.59616 5.6241 4.95508 4.83327 4.95508C4.04245 4.95508 3.40137 5.59616 3.40137 6.38699C3.40137 7.17783 4.04245 7.81889 4.83327 7.81889Z"
                        stroke="#ADADAD"
                        stroke-width="1.07393"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path d="M3.80371 14.9772C7.79154 7.88931 11.1064 6.64348 14.858 11.2471" stroke="#ADADAD" stroke-width="1.07393" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M8.61307 2.08984H3.40092C2.64139 2.08984 1.91297 2.39152 1.3759 2.92859C0.838827 3.46566 0.537109 4.19412 0.537109 4.95366V12.1132C0.537109 12.8728 0.838827 13.6011 1.3759 14.1382C1.91297 14.6752 2.64139 14.977 3.40092 14.977H11.9924C12.7519 14.977 13.4803 14.6752 14.0174 14.1382C14.5545 13.6011 14.8562 12.8728 14.8562 12.1132V8.53343"
                        stroke="#ADADAD"
                        stroke-width="1.07393"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path d="M13.2451 6.26474V0.537109" stroke="#ADADAD" stroke-width="1.07393" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M10.9551 2.82816L13.2461 0.537109L15.5372 2.82816" stroke="#ADADAD" stroke-width="1.07393" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <input type="file" (change)="onFileSelected($event)" accept="image/*" hidden />
                  </label>
                </div>

                <mat-progress-bar class="genie-progress-bar" mode="determinate" [value]="builderService.fileUploadProgress" *ngIf="showUploadProgress"></mat-progress-bar>
              </div>
              <p class="media-reorder-hint" *ngIf="imageUrl && imageUrl.length > 1 && !builderService.isStockManager">{{ 'Drag thumbnails to reorder, or drop one on the main image to make it the main image.' | translate }}</p>
            </div>
          </div>

          <!-- Tags Card -->
          <div class="form-card adding-card">
            <div class="card-header">
              <h3>{{ 'Tags' | translate }}</h3>
              <button type="button" class="add-attribute-btn" (click)="addTagCategory()" *ngIf="!builderService.isStockManager">
                <mat-icon>add</mat-icon>
                <span>{{ 'Add Tag' | translate }}</span>
              </button>
            </div>
            <div class="card-content">
              <!-- Empty State -->
              <div class="attributes-empty" *ngIf="!tags || tags.length === 0">
                <p>{{ 'No tags defined yet. Add tags like brands or colors to help customers find your product.' | translate }}</p>
              </div>

              <!-- Tags Form -->
              <div class="attributes-form" *ngIf="tags && tags.length > 0">
                <div class="attribute-item" *ngFor="let tag of tags; let i = index">
                  <div class="attribute-content">
                    <div class="attribute-container">
                      <!-- Tag Key -->
                      <div class="form-field">
                        <label class="field-label">{{ 'Key' | translate }}</label>
                        <mat-form-field appearance="outline">
                          <input matInput [value]="tag.key || ''" (change)="updateTagKey(i, $event)" placeholder="{{ 'e.g., brands' | translate }}" />
                        </mat-form-field>
                      </div>

                      <!-- Tag Values -->
                      <div class="form-field attribute-value-field">
                        <label class="field-label">{{ 'Values' | translate }}</label>
                        <mat-form-field appearance="outline" floatLabel="always">
                          <mat-chip-grid #tagChipGrid>
                            <input placeholder="{{ 'Type a value and press Enter' | translate }}" [matChipInputFor]="tagChipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addTagValue($event, i)" />
                          </mat-chip-grid>
                        </mat-form-field>
                        <mat-chip-set class="tags-row" *ngIf="tag.values?.length">
                          <mat-chip *ngFor="let val of tag.values" [removable]="true" (removed)="removeTagValue(i, val)">
                            {{ val }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                    </div>

                    <button type="button" class="attribute-remove-btn" (click)="removeTagCategory(i)" aria-label="Remove tag">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.1924 1.70711C10.583 1.31658 10.583 0.68342 10.1924 0.29289C9.80186 -0.09763 9.16866 -0.09763 8.77816 0.29289L5.24266 3.82844L1.70711 0.29289C1.31658 -0.09763 0.68342 -0.09763 0.29289 0.29289C-0.09763 0.68342 -0.09763 1.31658 0.29289 1.70711L3.82846 5.24264L0.29289 8.77814C-0.09763 9.16874 -0.09763 9.80184 0.29289 10.1923C0.68342 10.5829 1.31658 10.5829 1.70711 10.1923L5.24266 6.65684L8.77816 10.1923C9.16866 10.5829 9.80186 10.5829 10.1924 10.1923C10.583 9.80184 10.583 9.16874 10.1924 8.77814L6.65686 5.24264L10.1924 1.70711Z"
                          fill="#ADADAD"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Additional Info Card -->
          <div class="form-card">
            <div class="card-header">
              <h3>
                {{ 'Additional Info' | translate }} <span class="optional-text">({{ 'Optional' | translate }})</span>
              </h3>
            </div>
            <div class="card-content">
              <div class="form-field">
                <label class="field-label">{{ 'Badge' | translate }}</label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="badge" placeholder="{{ 'New In, Limited Edition...' | translate }}" />
                </mat-form-field>
              </div>

              <div class="form-field">
                <label class="field-label">{{ 'User Type' | translate }}</label>
                <div class="np-custom-select" (click)="toggleDropdown('userType', $event)">
                  <span class="select-value">{{ getOptionLabel(userTypeOptions, productForm.get('userType')?.value) }}</span>
                  <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="dropdownOpen['userType']" />
                </div>
                <div class="np-dropdown-panel" *ngIf="dropdownOpen['userType']" (click)="$event.stopPropagation()">
                  <div class="np-dropdown-option" *ngFor="let opt of userTypeOptions" [class.selected]="productForm.get('userType')?.value === opt.value" (click)="selectOption('userType', opt.value, $event)">
                    {{ opt.label | translate }}
                  </div>
                </div>
              </div>

              <div class="form-field">
                <label class="field-label">{{ 'Image Size' | translate }}</label>
                <div class="np-custom-select" (click)="toggleDropdown('imageSizeType', $event)">
                  <span class="select-value">{{ getOptionLabel(imageSizeOptions, productForm.get('imageSizeType')?.value) }}</span>
                  <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="dropdownOpen['imageSizeType']" />
                </div>
                <div class="np-dropdown-panel" *ngIf="dropdownOpen['imageSizeType']" (click)="$event.stopPropagation()">
                  <div class="np-dropdown-option" *ngFor="let opt of imageSizeOptions" [class.selected]="productForm.get('imageSizeType')?.value === opt.value" (click)="selectOption('imageSizeType', opt.value, $event)">
                    {{ opt.label | translate }}
                  </div>
                </div>
              </div>

              <div *ngIf="productForm.get('imageSizeType')?.value === 'custom'" class="form-row">
                <div class="form-field">
                  <label class="field-label">{{ 'Width' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="imageWidth" type="text" [placeholder]="'300px' | translate" />
                  </mat-form-field>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'Height' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="imageHeight" type="text" [placeholder]="'400px' | translate" />
                  </mat-form-field>
                </div>
              </div>

              <!-- Shipping Dimensions (Physical Products Only) -->
              <div *ngIf="productForm?.value?.productFormat === 'physical'" class="shipping-dimensions">
                <div class="form-field">
                  <label class="field-label">{{ 'Weight (kg)' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="weightKg" type="number" min="0" [placeholder]="'0.00' | translate" />
                  </mat-form-field>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'Length (cm)' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="lengthCm" type="number" min="0" [placeholder]="'0.00' | translate" />
                  </mat-form-field>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'Width (cm)' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="widthCm" type="number" min="0" [placeholder]="'0.00' | translate" />
                  </mat-form-field>
                </div>
                <div class="form-field">
                  <label class="field-label">{{ 'Height (cm)' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="heightCm" type="number" min="0" [placeholder]="'0.00' | translate" />
                  </mat-form-field>
                </div>
              </div>

              <!-- Size Chart (Physical Products Only) -->
              <div class="form-field" *ngIf="productForm?.value?.productFormat === 'physical'">
                <label class="field-label">{{ 'Size Chart' | translate }}</label>
                <div class="size-chart-upload">
                  <div class="uploaded-chart" *ngIf="productForm.value?.sizeChartUrl">
                    <button type="button" class="remove-chart" (click)="removeSizeChart()">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.1924 1.70711C10.583 1.31658 10.583 0.68342 10.1924 0.29289C9.80186 -0.09763 9.16866 -0.09763 8.77816 0.29289L5.24266 3.82844L1.70711 0.29289C1.31658 -0.09763 0.68342 -0.09763 0.29289 0.29289C-0.09763 0.68342 -0.09763 1.31658 0.29289 1.70711L3.82846 5.24264L0.29289 8.77814C-0.09763 9.16874 -0.09763 9.80184 0.29289 10.1923C0.68342 10.5829 1.31658 10.5829 1.70711 10.1923L5.24266 6.65684L8.77816 10.1923C9.16866 10.5829 9.80186 10.5829 10.1924 10.1923C10.583 9.80184 10.583 9.16874 10.1924 8.77814L6.65686 5.24264L10.1924 1.70711Z"
                          fill="#ADADAD"
                        />
                      </svg>
                    </button>
                    <img [src]="productForm.value?.sizeChartUrl" [alt]="'Size Chart' | translate" />
                  </div>
                  <label class="chart-upload-zone" *ngIf="!productForm.value?.sizeChartUrl">
                    <div class="upload-icon-circle">
                      <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                        <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" stroke="#F9FAFB" stroke-width="6.66667" />
                        <path
                          d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953"
                          stroke="url(#paint0_linear_3029_40085)"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <defs>
                          <linearGradient id="paint0_linear_3029_40085" x1="23.8178" y1="41.8996" x2="20.7349" y2="16.145" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#7CEEE6" />
                            <stop offset="0.495192" stop-color="#3A95B9" />
                            <stop offset="0.990385" stop-color="#004691" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <p class="upload-text">{{ 'Click to Upload Image' | translate }}</p>
                    <p class="upload-hint">PDF or Image ( Max 15 mb )</p>
                    <input type="file" hidden (change)="onSizeChartSelected($event)" accept="image/*,.pdf" />
                  </label>
                  <mat-progress-bar class="genie-progress-bar" mode="determinate" [value]="builderService.fileUploadProgress" *ngIf="showSizeChartUploadProgress"></mat-progress-bar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Digital Product Type Selection -->
      <div class="digital-type-section" *ngIf="!toggleLocked && productForm?.value?.productType === 'simple' && productForm?.value?.productFormat === 'digital'">
        <p class="section-title">{{ 'Choose Digital Product Type' | translate }}</p>
        <div class="digital-type-toggle">
          <button type="button" class="toggle-btn" [class.active]="selectedToggle === 'qr'" (click)="setToggle('qr')">
            {{ 'Show QR Table' | translate }}
          </button>
          <button type="button" class="toggle-btn" [class.active]="selectedToggle === 'pdf'" (click)="setToggle('pdf')">
            {{ 'Add Document' | translate }}
          </button>
        </div>
      </div>

      <!-- Document Upload Section -->
      <div class="document-upload-section" *ngIf="showPdfInput && productForm?.value?.productType === 'simple' && productForm?.value?.productFormat === 'digital'">
        <div class="form-card">
          <div class="card-header">
            <h3>{{ 'Documents' | translate }}</h3>
          </div>
          <div class="card-content">
            <div class="document-upload" [class.drag-over]="dragOver" (drop)="onDocumentDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
              <!-- Empty State -->
              <div class="upload-placeholder" *ngIf="documentUrls.length === 0" [class.uploading]="currentUploadProgress || currentUploadName">
                <div class="upload-icon">
                  <img src="assets/images/products/files-icon.png" [alt]="'Upload' | translate" />
                </div>
                <p class="upload-text">{{ 'Drop files here to upload' | translate }}</p>
                <p class="upload-divider">{{ 'OR' | translate }}</p>
                <label class="upload-btn">
                  {{ 'Browse Files' | translate }}
                  <input type="file" hidden (change)="onDocumentSelected($event)" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.odt,.csv,.tsv,.html,.htm,.ods,image/*" multiple />
                </label>
              </div>

              <!-- Uploaded Documents List -->
              <div *ngIf="documentUrls.length > 0" class="document-list">
                <div *ngFor="let pdf of documentUrls; let i = index" class="document-item">
                  <button type="button" class="document-delete" (click)="removePdf(i)">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.1924 1.70711C10.583 1.31658 10.583 0.68342 10.1924 0.29289C9.80186 -0.09763 9.16866 -0.09763 8.77816 0.29289L5.24266 3.82844L1.70711 0.29289C1.31658 -0.09763 0.68342 -0.09763 0.29289 0.29289C-0.09763 0.68342 -0.09763 1.31658 0.29289 1.70711L3.82846 5.24264L0.29289 8.77814C-0.09763 9.16874 -0.09763 9.80184 0.29289 10.1923C0.68342 10.5829 1.31658 10.5829 1.70711 10.1923L5.24266 6.65684L8.77816 10.1923C9.16866 10.5829 9.80186 10.5829 10.1924 10.1923C10.583 9.80184 10.583 9.16874 10.1924 8.77814L6.65686 5.24264L10.1924 1.70711Z"
                        fill="#ADADAD"
                      />
                    </svg>
                  </button>
                  <img [src]="getFileIcon(pdf)" [alt]="'File Icon' | translate" class="document-icon" />
                  <span class="document-name">{{ pdf.name || 'Untitled Document' }}</span>
                </div>
                <label class="add-more-documents">
                  <mat-icon>add</mat-icon>
                  {{ 'Add More' | translate }}
                  <input type="file" hidden (change)="onDocumentSelected($event)" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.odt,.csv,.tsv,.html,.htm,.ods,image/*" multiple />
                </label>
              </div>

              <mat-progress-bar class="genie-progress-bar" *ngIf="currentUploadName" mode="determinate" [value]="currentUploadProgress"></mat-progress-bar>
            </div>
          </div>
        </div>
      </div>

      <!-- QR Codes Section (Simple Digital Products) -->
      <div class="expansion-section codes-section" *ngIf="productForm?.value?.productType === 'simple' && productForm?.value?.productFormat === 'digital' && showQrTable">
        <mat-accordion>
          <mat-expansion-panel class="genie-expansion-panel" hideToggle (opened)="CodeOpen = true" (closed)="CodeOpen = false" [expanded]="true" [disabled]="true" #QrCodeMep="matExpansionPanel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="expand-icon material-icons" [class.rotated]="CodeOpen">expand_more</span>
                {{ 'Code' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="codes-header">
                <h4>{{ 'Enter Data for QR Code' | translate }}</h4>
                <div class="codes-input-row">
                  <input type="text" class="code-input" [(ngModel)]="newCodeSimple" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Enter Code' | translate }}" />
                  <button (click)="addCode()" type="button" class="btn-primary">{{ 'Add' | translate }}</button>
                </div>
              </div>

              <mat-tab-group class="codes-tabs" (selectedTabChange)="filterQrCodesByTab($event.index)">
                <mat-tab>
                  <ng-template mat-tab-label>{{ 'All' | translate }}</ng-template>
                  <ng-template matTabContent>
                    <ng-container *ngTemplateOutlet="qrTable"></ng-container>
                  </ng-template>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>{{ 'Purchased' | translate }}</ng-template>
                  <ng-template matTabContent>
                    <ng-container *ngTemplateOutlet="qrTable"></ng-container>
                  </ng-template>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>{{ 'Valid' | translate }}</ng-template>
                  <ng-template matTabContent>
                    <ng-container *ngTemplateOutlet="qrTable"></ng-container>
                  </ng-template>
                </mat-tab>
              </mat-tab-group>

              <ng-template #qrTable>
                <div class="codes-table-wrapper">
                  <table mat-table [dataSource]="filteredCodes" class="codes-table">
                    <ng-container matColumnDef="Code">
                      <th mat-header-cell *matHeaderCellDef>{{ 'Code' | translate }}</th>
                      <td mat-cell *matCellDef="let code">{{ code.value }}</td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef>{{ 'Type' | translate }}</th>
                      <td mat-cell *matCellDef="let code; let i = index">
                        <div class="code-type-select-wrap">
                          <div class="np-custom-select type-select" (click)="toggleCodeTypeDropdown(i, undefined, $event)">
                            <span class="select-value">{{ getOptionLabel(codeTypeOptions, code.codeType) }}</span>
                            <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="codeTypeDropdownSimple[i]" />
                          </div>
                          <div class="np-dropdown-panel" *ngIf="codeTypeDropdownSimple[i]" (click)="$event.stopPropagation()">
                            <div class="np-dropdown-option" *ngFor="let opt of codeTypeOptions" [class.selected]="code.codeType === opt.value" (click)="selectCodeTypeOption(i, undefined, opt.value, $event)">
                              {{ opt.label | translate }}
                            </div>
                          </div>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="used">
                      <th mat-header-cell *matHeaderCellDef>{{ 'Purchased' | translate }}</th>
                      <td mat-cell *matCellDef="let code; let i = index">
                        <label class="toggle-switch">
                          <input type="checkbox" [checked]="code.used" (change)="onToggleUsed(i)" />
                          <span class="toggle-slider"></span>
                        </label>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>{{ 'Action' | translate }}</th>
                      <td mat-cell *matCellDef="let code; let i = index">
                        <button mat-icon-button type="button" class="delete-btn" (click)="removeCode(i)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['Code', 'type', 'used', 'action']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['Code', 'type', 'used', 'action']"></tr>
                  </table>
                  <mat-paginator [length]="filteredCodes.filteredData.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                </div>
              </ng-template>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
</div>
